<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="`/project/info/${this.projectId}`">
      </f7-nav-left>
      <f7-nav-title>评价上级</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="save">保存</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="has-content">
      <f7-block>
        <div class="evaluate-score">
        <div>评价：</div>
        <div
          class="evaluate-score-star"
          v-for="item in scoreList"
          :key="item"
          @click="evaluate.score = item">
          <f7-icon
            size="1.2rem"
            color="yellow"
            :fa="item <= evaluate.score ? 'star' : 'star-o'">
          </f7-icon>
        </div>
      </div>
        <div class="evaluate-comments">
          <f7-list inline-labels id="evaluateForm">
            <f7-list-input
              type="textarea"
              :value="evaluate.evaluateRemark"
              @input="evaluate.evaluateRemark = $event.target.value"
              placeholder="请填写评价说明"
              required
              validate
              minlength=2
              maxlength=100
              error-message="必填项，2-100个字符"
              inputStyle="text-align: left; padding-top: 0rem;"
              style="width: 100%; height: 100%;"
              resizable>
            </f7-list-input>
          </f7-list>
        </div>
      </f7-block>
    </div>
  </f7-page>
</template>
<script>
import { evaluateSuperior } from '@/api/project/project';
import { createToast } from '@/util/compUtils';

export default {
  props: ['project', 'projectId'],
  data() {
    return {
      scoreList: [1, 2, 3, 4, 5],
      evaluate: {
        projectId: this.projectId,
        score: '',
        evaluateRemark: '',
        companyId: '',
      },
    };
  },
  methods: {
    save() {
      // this.$f7.input.validateInputs('#evaluateForm');
      let valided = true;
      this.$$('#evaluateForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      if (valided) {
        evaluateSuperior(this.evaluate).then((data) => {
          if (data.code === 0) {
            createToast(this, '评价成功');
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .evaluate-comments {
    margin: 1rem 0rem;
    padding: 0rem 0.5rem;
    border: 0.05rem solid $border-color;
    border-radius: 0.3rem;
  }

  .evaluate-score {
    display: flex;
    margin: 2rem 0rem;
  }

  .evaluate-score-star {
    cursor: pointer;
    padding: 0rem 0.25rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/project/evaluate.vue